import { render } from "./ConsequencesLadder.vue?vue&type=template&id=51a46c72"
import script from "./ConsequencesLadder.vue?vue&type=script&lang=js"
export * from "./ConsequencesLadder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__